<template>
    <div id="pagefoot">
      版权信息：copyright © 2016 - 2021 成都码邻蜀科技有限公司
    </div>
</template>

<script>
    export default {
        name: "PageFooter"
    }
</script>

<style scoped>
#pagefoot{
  width: 100%;
  font-size: 12px;
  color: #999;
  padding-top: 44px;
  padding-bottom: 48px;
  text-align: center;
  border-top: 1px solid #E2E2E2;
  height: 106px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/assembly/PageFooter.vue